/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import cIf from 'classnames';
import { CartItem, ProductDeliveryShippingFee } from '../../src/types/models/mvcapi';
import { UUID } from '../../src/types/basetypes';

const tr = require('ts-translate-js').default.boundTR;
const accounting = require('accounting');

interface DeliveryRuleProps {
    cartItem: CartItem,
    onUpdateDeliveryMethod: (isMailDelivery: boolean, isEticketDelivery: boolean, shippingFeeId: UUID) => void,
    emphasisOnUnsetShipping: boolean
}



class DeliveryRule extends Component<DeliveryRuleProps> {
    handleUpdateDeliveryMethod(isMailDelivery: boolean, isEticketDelivery: boolean, shippingFeeId: UUID = undefined) {
        this.props.onUpdateDeliveryMethod(isMailDelivery, isEticketDelivery, shippingFeeId);
    }

    render(){
        let deliveryMethod = tr("cartcontent.boxoffice");
        let deliveryOptions = [];
        //let item: CartItem;

        // if (this.props.cartItem.SubProducts.length > 0)
        //     item = this.props.cartItem.SubProducts[0];
        // else
        //     item = this.props.cartItem;

        if (!this.props.cartItem.DeliveryMethodSet)
            deliveryMethod = tr("cartcontent.setdeliverymethod");
        else {
            
            if (this.props.cartItem.IsMailDelivery) {
                let shipMethodFee = this.props.cartItem.DeliveryRules.ShippingMethodFees.find((sf) => sf.MethodId == this.props.cartItem.ShippingFeeID);
                deliveryMethod = formatShippingMethodName(shipMethodFee, this.props.cartItem.ShippingFees);
                
            } else if (this.props.cartItem.IsEticketDelivery)
                deliveryMethod = tr("cartcontent.eticket");
        }

        if (this.props.cartItem.DeliveryRules.IsETicketDeliveryAvailable)
            deliveryOptions.push(<li key="eticket" onClick={() => { this.handleUpdateDeliveryMethod(false, true); }}><a href="#"><span className="glyphicon glyphicon-phone"></span>&nbsp;{tr("cartcontent.eticket")}</a></li>);
        if (!this.props.cartItem.DeliveryRules.IsDeliveryMandatory)
            deliveryOptions.push(<li key="boxoffice" onClick={() => { this.handleUpdateDeliveryMethod(false, false); }}><a href="#"><span className="glyphicon glyphicon-user"></span>&nbsp;{tr("cartcontent.boxoffice")}</a></li>);
        if (this.props.cartItem.DeliveryRules.IsMailDeliveryAvailable) {
            this.props.cartItem.DeliveryRules.ShippingMethodFees.forEach((shippingMethodFee) => {
                deliveryOptions.push(<li key={shippingMethodFee.MethodId} onClick={() => { this.handleUpdateDeliveryMethod(true, false, shippingMethodFee.MethodId); }}><a href="#"><span className="glyphicon glyphicon-envelope"></span>&nbsp;{formatShippingMethodName(shippingMethodFee)}</a></li>);
            });
        }
            

        //Comme il y a un risque que l'usager configure de façon erronée la livraison, il faudra probablement se backé en mettant "boxoffice" si jamais aucune option n'est présente
        const warnShippingUnset = this.props.emphasisOnUnsetShipping && !this.props.cartItem.DeliveryMethodSet;

        return <div className="btn-group">
            <button
                className={cIf([ "btn", "dropdown-toggle", { "btn-danger": warnShippingUnset, "btn-xs": !warnShippingUnset, "btn-info": !warnShippingUnset } ])} type="button" data-toggle="dropdown" id="deliveryDropdown" aria-haspopup="true" aria-expanded="true">
                {deliveryMethod + " "}
                <span className="caret"></span>
            </button>
            <ul className="dropdown-menu" aria-labelledby="deliveryDropdown">
                {deliveryOptions}
            </ul>
        </div>;
        
    }
}

function formatShippingMethodName(shipMethodFee: ProductDeliveryShippingFee, otherFeeValue: number = null): string {
    let name = tr("cartcontent.mail"); 
    let amount = null;

    if(shipMethodFee) {
        name = tsapp.twoLetterLang === "en" ? shipMethodFee.NameEn : shipMethodFee.NameFr;
        amount = shipMethodFee.Amount;
    }

    if(otherFeeValue != null) {
        amount = otherFeeValue;
    }
    
    let amountStr = amount != null && amount > 0 ? " - " + accounting.formatMoney(amount) : ""; // Write the amount only if its an extra to make tu UI better.

    return name + amountStr;
}

// eslint-disable-next-line import/no-default-export
export default DeliveryRule;